<template>
  <main id="container" class="page-container event-linked-page">
    <div class="page-content event-check relation-eventPage event-bg">
      <div class="container">
        <section>
          <!-- 코그페 메인 타이틀 영역 -->
          <div class="conTitArea line">
            <h2>이벤트 안내</h2>
          </div>

          <div class="detailCon">
            <!-- tab -->
            <div class="tab tabFunc">
              <div class="tabMenu mScrollArea">
                <ul class="lineBtn">
                  <li :class="{ curr: isTabActive('purchase') }">
                    <router-link to="/ko/event/purchase">소비인증 캠페인</router-link>
                  </li>
                  <li :class="{ curr: isTabActive('store') }">
                    <router-link to="/ko/event/store">코그페 스토어 인증</router-link>
                  </li>
                  <li :class="{ curr: isTabActive('delivery') }">
                    <router-link to="/ko/event/delivery">공공배달앱 할인</router-link>
                  </li>
                  <li :class="{ curr: isTabActive('linked') }">
                    <router-link to="/ko/event/LinkedPage">연계이벤트</router-link>
                  </li>
                </ul>
              </div>

              <div class="tabCon">
                <div class="event-check-container">
                  <div class="event-header">
                    <h3>연계 이벤트</h3>
                    <span class="event-total"
                      >전체 <b>{{ totalCount }}건</b></span
                    >
                  </div>

                  <ul class="list-content">
                    <li
                      v-for="(item, index) in eventList"
                      :key="item.orgName"
                      :class="['list', `list-${item.color}`]"
                    >
                      <div class="event-lt">
                        <div class="list-order">
                          {{ String(index + 1).padStart(2, "0") }}
                        </div>

                        <div class="event-info">
                          <p class="org-name">{{ item.orgName }}</p>
                          <p class="event-title">{{ item.title }}</p>
                          <p class="event-content">
                            {{ item.content }}
                          </p>
                        </div>
                      </div>

                      <button type="button" @click="clickLink(item.link)">
                        이벤트 바로가기
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </main>
</template>

<script>
import EventTermsModal from "@/components/content/EventTermsModal";
import { mapGetters } from "vuex";

export default {
  name: "EventLinkedPage",
  components: { EventTermsModal },
  data: () => ({
    totalCount: 5,
    eventList: [
      {
        color: "purple",
        orgName: "소상공인시장진흥공단",
        title: "사전 붐업 이벤트",
        content:
          "사전 홍보 콘텐츠를 지정 해시태그와 함께 SNS 공유",
        link: "https://www.sijangae.or.kr/",
      },
      {
        color: "green",
        orgName: "소상공인시장진흥공단",
        title: "SNS 인증 이벤트",
        content:
          "내가 추천하는 우리동네 전통시장·상점가 음식점을 촬영해 지정 해시태그와 함께 SNS 소개",
        link: "https://www.sijangae.or.kr/",
      },
      {
        color: "red",
        orgName: "소상공인시장진흥공단",
        title: "영수증 인증 이벤트",
        content: "전통시장·상점가에서 5만원 이상 구매 시 1만원 온누리 페이백 (1인 최대 2회)",
        link: "https://www.sijangae.or.kr/",
      },
      {
        color: "blue",
        orgName: "소상공인시장진흥공단",
        title: "만족도 조사 이벤트",
        content: "참여 경험과 만족도에 대한 설문 참여 이벤트",
        link: "https://www.sijangae.or.kr/",
      },
      {
        color: "yellow",
        orgName: "중기중앙회",
        title: "홈앤쇼핑 별도기획전",
        content: "코리아그랜드페스티벌 기간 중 구매고객 래플 경품/7% 추가적립+7% 카드할인 ",
        link: "https://m.hnsmall.com/category/planshop/2026087122",
      },
    ],
  }),

  computed: {
    ...mapGetters("common", ["isMobile", "commonCode", "campn"]),
    ...mapGetters("auth", ["session", "isAuth"]),
  },
  watch: {},
  async created() {},
  mounted() {},
  methods: {
    isTabActive(tab) {
      const path = (this.$route && this.$route.path ? this.$route.path : "").toLowerCase();
      if (tab === "purchase") return path.includes("purchase");
      if (tab === "store") return path.includes("store");
      if (tab === "delivery") return path.includes("delivery");
      if (tab === "linked") return path.includes("linked");
      return false;
    },
    clickLink(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped>
/* 페이지 여백 (배경은 event-bg의 sub_bg.svg 그대로 유지) */
.event-linked-page .page-content {
	margin-top: 0 !important;
	margin-bottom: 60px !important;
	padding-top: 20px !important;
	padding-bottom: 60px !important;
}

.event-linked-page .container {
	max-width: 1640px;
	margin: 0 auto;
	padding: 0 20px;
}

/* 타이틀 영역 (이벤트 안내) */
.conTitArea {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 40px 0 30px;
}

.conTitArea.line {
	border-bottom: 2px solid #000;
}

.conTitArea h2 {
	font-weight: 700;
	font-size: 34px;
	color: #000;
	margin: 0;
}

/* 탭 메뉴 */
.detailCon {
	margin: 40px auto 0;
}

.tabMenu.mScrollArea {
	width: 100%;
	overflow-x: auto;
}

.tabMenu ul {
	display: flex;
	align-items: center;
	gap: 10px;
	list-style: none;
	padding: 0;
	margin: 0;
}

.tabMenu .lineBtn {
	justify-content: flex-start;
	gap: 20px;
}

.tabMenu .lineBtn li {
	min-width: 103px;
	background: #fff;
	border-radius: 8px;
	border: 1px solid #11194f;
	overflow: hidden;
flex-shrink: 0;
}

.tabMenu .lineBtn li a {
	display: block;
	padding: 13px 24px;
	width: 100%;
	border: none;
	font-weight: 400;
	color: #11194f;
	font-size: 20px;
	text-align: center;
	letter-spacing: -1.2px;
	text-decoration: none;
}

.tabMenu ul.lineBtn li.curr a,
.tabMenu ul.lineBtn li a.router-link-exact-active,
.tabMenu ul.lineBtn li a:hover {
	background: #252c5d;
	color: #fff !important;
	font-weight: 700;
}

.tabCon {
	padding: 30px 0 100px 0;
}

/* 연계이벤트 컨테이너 내부 여백 조정 */
.event-linked-page .event-check-container {
	padding: 10px 0 60px 0;
	max-width: 1058px;
	margin: 0 auto;
}

/* 미디어 쿼리 반응형 (공공배달앱 할인과 완전 동일) */
@media (max-width: 1280px) {
	.tabMenu ul {
		gap: 30px;
		width: 100%;
	}
}

@media (max-width: 940px) {
	.tabMenu ul li a {
		line-height: 23px;
		font-size: 20px;
	}

	.tabMenu .lineBtn {
		gap: 10px;
	}
}

@media (max-width: 768px) {
	.conTitArea {
		padding: 30px 0 20px;
	}

	.conTitArea h2 {
		font-size: 26px;
	}

	.detailCon {
		margin-top: 24px;
	}

	.tabMenu .lineBtn li a {
		padding: 10px 18px;
		font-size: 16px;
	}

	.tabCon {
		padding: 20px 0 60px 0;
	}
}

@media (max-width: 767px) {
	.tabMenu {
		padding-bottom: 0px;
	}

	.tabMenu ul {
		gap: 20px;
		padding-bottom: 20px !important;
		flex-wrap: nowrap !important;
	}

	.tabMenu ul li a {
		font-size: 17px;
	}

	.tabMenu .lineBtn li a {
		padding: 8px 18px;
		line-height: inherit;
		font-size: 18px;
	}
}
</style>
